export const tagMetadataKeys = {
	ExportStoppedKey: 'export_stopped',
	ExportStartedKey: 'export_started',
	SourceUriKey: 'source_uri',
	TrueValue: 'True'
} as const
